import * as React from 'react';
import styled from 'styled-components';

import { Button } from 'components/bootstrap';

const StyledButton = styled(Button)`
  border-radius: 4px;
  width: 110px;
`;

type Props = {
  title: string;
  to: string;
}

const EventProcedureLinkButton = ({ title, to }: Props) => (
  <a href={to} target="_blank" rel="noopener noreferrer">
    <StyledButton bsStyle="gray" bsSize="xs" aria-label={title}>{title}</StyledButton>
  </a>
);

export default EventProcedureLinkButton;
